import {parseParams} from '@wix/music-shared/dist/src/utils/url';
import Experiments, {ExperimentsBag} from '@wix/wix-experiments';
import {createSelector} from 'reselect';
import {AppContext} from '../../machines/appMachine/AppContext';
import {getInstance} from '../../services/env/instance/instance';
import {getPaymentsId} from '../../services/env/paymentsId/paymentsId';
import {ExperimentNames} from '../../services/experiments/ExperimentNames';

export const albumSelector = (store) => store.album;
export const trackSelector = (store) => store.track;
export const sTokenSelector = (store) => store.siteSettings.sToken;
export const siteInfoSelector = (store) => (store.siteInfo ? store.siteInfo : {});
export const emailSelector = (store) => store.email;
export const paymentErrorMessageSelector = (store) => store.paymentErrorMessage;

export const instanceSelector = (store) => store.instance || getInstance();

export const dgsParamsSelector = createSelector(
  [sTokenSelector, siteInfoSelector, albumSelector, trackSelector],
  (sToken, siteInfo, album, track) => ({
    instance: getInstance(),
    paymentsId: getPaymentsId(),
    sToken,
    ref: siteInfo ? siteInfo.url : null,
    albumId: album.id,
    ...(track ? {trackId: track.id} : {}),
  }),
);

export const snapshotIdSelector = (store) => store.snapshotId;

export const experimentSelector = (store: AppContext): Experiments =>
  new Experiments({experiments: store.experiments as ExperimentsBag});

export const isExperimentEnabled = (name: ExperimentNames) =>
  createSelector(experimentSelector, (experiments) => experiments.enabled(name));

export const redirectParamsSelector = createSelector([albumSelector, trackSelector], (album, track) => {
  const {vsi, compId, deviceType, locale, origCompId, pageId} = parseParams();
  return {
    vsi,
    compId,
    deviceType,
    locale,
    origCompId,
    pageId,
    viewMode: 'standalone',
    albumId: album.id,
    ...(track ? {trackId: track.id} : {}),
  };
});

export const isCashierWidgetLoadingSelector = (store) => store.cashierWidgetLoading;
export const downloadLinksSelector = (store) => store.downloadLinks;
export const isIosSelector = (context) => context.isIos;
export const mandatoryFieldsSelector = (context: AppContext) => context.mandatoryFields;
